import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {FooterComponent} from "../components/footer/footer.component";
import {HeaderComponent} from "../components/header/header.component";
import {HttpModule} from "@angular/http";
import {DynamicHTMLOutlet} from "../directives/dynamic-html-outlet.directive";
import {HomeComponent} from "../components/home/home.component";
import {LoginComponent} from "../components/login/login.component";
import {SignUpComponent, BusinessUserSignupComponent} from "../components/sign-up";
import {DynamicPageComponent} from "../components/dynamic-page/dynamic-page.component";
import {ModalModule, AlertModule, AccordionModule, TooltipModule, BsDropdownModule,} from 'ngx-bootstrap';
import {OrderBy} from "../directives/order-by.pipe";
import {AppProfileComponent} from "../components/app-profile/app-profile.component";
import {ForgotPasswordComponent} from "../components/user/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "../components/user/reset-password/reset-password.component";
import {PaginationDirective} from "../directives/pagination.directive";
import {ScrollSpyDirective} from "../directives/scroll-spy.directive";
import {AppTileComponent} from "./app-tile/app-tile.component";
import {PricingPlanComponent} from "./pricing-plan/pricing-plan.component";
import {SafePipe} from "../directives/safe.pipe";
import {LoginWidgetComponent} from "./login-widget/login-widget.component";
import {InfiniteScrollModule} from "angular2-infinite-scroll";
import {AlertMessageComponent} from "./alert-message/alert-message.component";
import {LoadingSpinnerComponent} from "./loading-spinner/loading-spinner.component";
import { MultiselectDropdownComponent } from './multiselect-dropdown/multiselect-dropdown.component';
import {MultiselectDropdownModule} from "angular-2-dropdown-multiselect";
import {TagInputModule} from "ng2-tag-input";
import { TooltipComponent } from './tooltip/tooltip.component';
import { AppInquiryComponent } from '../components/app-profile/app-inquiry/app-inquiry.component';
import {FileUploadDirective} from "../directives/file-upload.directive";
import {UploadFileModelComponent} from './upload-file/upload-file-model.component';



/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({
  imports: [
    CommonModule, FormsModule, HttpModule, RouterModule, ModalModule.forRoot(), AlertModule.forRoot(), TooltipModule.forRoot(),
    ReactiveFormsModule, InfiniteScrollModule, MultiselectDropdownModule, TagInputModule, AccordionModule.forRoot()
  ],
  declarations: [
    HeaderComponent, FooterComponent, DynamicHTMLOutlet, AppInquiryComponent, FileUploadDirective,
    HomeComponent, LoginComponent, SignUpComponent, DynamicPageComponent, OrderBy, ScrollSpyDirective,
    AppProfileComponent, ForgotPasswordComponent, ResetPasswordComponent, PaginationDirective,
    PricingPlanComponent, AppTileComponent, BusinessUserSignupComponent, SafePipe,
    LoginWidgetComponent, AlertMessageComponent, LoadingSpinnerComponent, MultiselectDropdownComponent, TooltipComponent, UploadFileModelComponent
  ],
  exports: [
    CommonModule, FormsModule, RouterModule, HttpModule, ModalModule, AlertModule, AppInquiryComponent,
    HeaderComponent, FooterComponent, DynamicHTMLOutlet, OrderBy, LoginComponent,
    SignUpComponent, PaginationDirective, ScrollSpyDirective, SafePipe,
    AppProfileComponent, ForgotPasswordComponent, ResetPasswordComponent,
    PricingPlanComponent, AppTileComponent, BusinessUserSignupComponent, ReactiveFormsModule,
    LoginWidgetComponent, AlertMessageComponent, LoadingSpinnerComponent, InfiniteScrollModule, MultiselectDropdownComponent,
    MultiselectDropdownModule, TagInputModule, AccordionModule, TooltipComponent, TooltipModule, FileUploadDirective, UploadFileModelComponent
  ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts